import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Spin from 'antd/lib/spin';
import Divider from 'antd/lib/divider';
import { useParams } from 'react-router-dom';
import { getIncentiveByBuilding } from 'parity-network-requests';
import { config } from '../../../../config';

// ICONS
import moneyIcon from './assets/money.svg';

import './Incentives.less';
import { CircleChart } from '../../../CircleChart';

const { REACT_APP_BUILD_ENV } = config;

export const Incentives = (props) => {
  const { theme, buildingName } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [buildingIncentive, setBuildingIncentive] = useState([]);
  const [cumulativeApplied, setCumulativeApplied] = useState(0);
  const [cumulativeApproved, setCumulativeApproved] = useState(0);
  const { building } = useParams();

  const calculateCumulativeIncentive = (buildingIncentiveData) => {
    let tmpCumulativeApplied = 0;
    let tmpCumulativeApproved = 0;

    buildingIncentiveData.forEach((incentive) => {
      const { approved_amount, applied_amount } = incentive;

      tmpCumulativeApplied += applied_amount;
      tmpCumulativeApproved += approved_amount;
    });

    setCumulativeApplied(tmpCumulativeApplied);
    setCumulativeApproved(tmpCumulativeApproved);
  };

  useEffect(() => {
    async function fetchData() {
      const buildingIncentiveData = await getIncentiveByBuilding(REACT_APP_BUILD_ENV, building);
      setBuildingIncentive(buildingIncentiveData);
      calculateCumulativeIncentive(buildingIncentiveData);
      setIsLoading(false);
    }
    fetchData();
    window.document.title = `${buildingName} | Incentives`;
  }, [building]);

  return (
    <div className="incentives-wrapper">
      <div className={`incentives__card incentives__card-${theme}`}>
        {isLoading ? (
          <div className="incentives__card--loading">
            <Spin />
          </div>
        ) : (
          <>
            <div className="incentives__card--header">
              <div className="incentives__card--title">Status on Incentives</div>
            </div>
            <div className="incentives__card--body">
              <div className="incentives__card--graph">
                <CircleChart
                  title1="Received"
                  title2="Applied for:"
                  color="#BE9245"
                  target={cumulativeApplied}
                  actual={cumulativeApproved}
                  currency="CAD"
                  theme={theme}
                />
              </div>
              <div className="incentives__card--legend-wrapper">
                <div className="incentives__card--legend">
                  <div className="incentives__card--legend-row">
                    <div>
                      <div className="incentives__card--legend-circle received" />
                      Received so far
                    </div>
                  </div>
                  <div className="incentives__card--legend-row">
                    <div>
                      <div className="incentives__card--legend-circle applied" />
                      Applied for
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      {buildingIncentive.length > 0 && (
        <div className={`incentives__information incentives__information-${theme}`}>
          <div className="incentives__information--title">Incentives in progress</div>

          {buildingIncentive.map((incentiveObj, index) => {
            const {
              applied_amount,
              applied_amount_currency,
              approved_amount,
              approved_amount_currency,
              state,
              incentive_provider_name,
              modified,
            } = incentiveObj;

            const formattedApprovedAmount = approved_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            const formatAppliedAmount = applied_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            return (
              <>
                <div className="incentives__information--section">
                  <div className="incentives__information--section-header">
                    <img src={moneyIcon} className="incentives__information--money" alt="money-icon" />
                    <div className="incentives__information--section-title">{`$${formattedApprovedAmount} ${approved_amount_currency}`}</div>
                  </div>
                  <div className="incentives__information--section-row">
                    <div className="incentives__information--section-row-item left">Incentive:</div>
                    <div className="incentives__information--section-row-item right">{incentive_provider_name}</div>
                  </div>
                  <div className="incentives__information--section-row">
                    <div className="incentives__information--section-row-item left">Amount Applied:</div>
                    <div className="incentives__information--section-row-item right">{`$${formatAppliedAmount} ${applied_amount_currency}`}</div>
                  </div>
                  <div className="incentives__information--section-row">
                    <div className="incentives__information--section-row-item left">Status:</div>
                    <div className="incentives__information--section-row-item right">{state}</div>
                  </div>
                  <div className="incentives__information--section-row">
                    <div className="incentives__information--section-row-item left">Last Updated:</div>
                    <div className="incentives__information--section-row-item right">
                      {moment(modified).utc().format('LL')}
                    </div>
                  </div>
                </div>
                {index !== buildingIncentive.length - 1 && <Divider style={{ color: '#ced7e0', width: '80%' }} />}
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};
